// @flow

import { getPlayerType, FLASH_TYPE } from './players';

import { extend, existy, notExisty, isNotEmpty, contains } from './utils';

import type { Player$CombineOptions, Player$InputOptions } from './types/Options';

import isMobile from './helpers/isMobile';
import isAndroid from './helpers/isAndroid';
import isCanvasSupported from './helpers/isCanvasSupported';
import { isIE8 } from './helpers/isIE';
import { isWindows10 } from './helpers/isWindows';
import isiOS from './helpers/isiOS';

import SOURCE_OPTIONS from './config/source';

const AUDIO_TYPES = [ 'audio/mp3', 'audio/mpeg', 'audio/mp4' ];

// eslint-disable-next-line
export default function normalize(common: $Shape<Player$InputOptions>, options: $Shape<Player$CombineOptions>): $Shape<Player$CombineOptions> {
   options =  extend({}, SOURCE_OPTIONS, common, options);
   const custom: $Shape<Player$CombineOptions> = {
      showAnnotations: existy(options.showAnnotations) ? options.showAnnotations : true,
      showQuality: existy(options.showQuality) ? options.showQuality : true,
      showPlaceholder: existy(options.showPlaceholder) ? options.showPlaceholder : true
   };

   custom.showPoster = options.showPoster && existy(options.poster);

   if (options.showHelp) {
      custom.showHelp = isCanvasSupported();
   }

   if (_isAudio(options.type) || options.isAudio) {
      custom.showFullScreen = false;
      custom.showClosedCaptions = false;
      custom.showTOC = false;
      custom.showAnnotations = false;
      custom.showQuality = false;
      custom.isAudio = true;
      // =(
      // options.showSettings = false;
   }

   if (isMobile()) {
      custom.showVolume = false;
      custom.showQuality = false;
      custom.showHelp = false;
      custom.preview = null;
      custom.showTitle = false;
      custom.showCCLayout = false;
      custom.isMobile = true;

      custom.extensionsVisibilityTimeout = 4000;
   }

   if (isAndroid()) {
      custom.showPlaybackRate = false;
   }

   if (isIE8()) {
      custom.showCCLayout = false;
      custom.useMux = false;
   }

   if (!options.startTime && isiOS()) {
      custom.startTime = 0.5;
   }

   if (notExisty(options.annotations)) {
      custom.showAnnotations = false;
   }

   if (options.startTime && !custom.isAudio) {
      custom.showPoster = false;
   }

   const type = getPlayerType(options);
   if (type === FLASH_TYPE) {
      custom.showPlaybackRate = false;
   }

   // if (options.showClosedCaptions) {
   //    custom.showClosedCaptions = existy(options.cc) && isNotEmpty(options.cc);
   // }

   // if (options.showTOC) {
   //    custom.showTOC = existy(options.chapters) && isNotEmpty(options.chapters);
   // }

   if (options.showAnnotations) {
      custom.showAnnotations = existy(options.annotations) && isNotEmpty(options.annotations);
   }

   if ( custom.showAnnotations === false && custom.showPlaybackRate === false && custom.showQuality === false ) {
      custom.showSettings = false;
      options.showSettings = false;
   }

   custom.showDownloadCC = options.showDownloadCC && existy(options.cc) && isNotEmpty(options.cc);

   if (options.showDownloadVideo) {
      custom.showDownloadVideo = isWindows10() && existy(options.downloadURL) && isNotEmpty(options.downloadURL);
   }

   custom.showDownload = options.showDownload && (custom.showDownloadVideo || custom.showDownloadCC || !!options.downloadVideoURL);

   custom.showCaptionSearch = options.showCaptionSearch && existy(options.cc) && isNotEmpty(options.cc);

   if (!options.showExtensions) {
      custom.showPlay = false;
      custom.showProgress = false;
      custom.showVolume = false;
      custom.showFullScreen = false;
      custom.showClosedCaptions = false;
      custom.showTOC = false;
      custom.showAnnotations = false;
      custom.showQuality = false;
      custom.showPoster = false;
      custom.showPlaceholder = false;
      custom.showPlaybackRate = false;
      custom.showForward = false;
      custom.showBackward = false;
      custom.showSettings = false;
      custom.showDownload = false;
      custom.showHelp = false;
      custom.showTitle = false;
      custom.showNext = false;
   }

   const res = extend(options, custom);

   return res;
}

function _isAudio(type) {
   return contains(AUDIO_TYPES, type);
}
